/**
 * QR-2 В2: имя отправителя в комнате. Чистый модуль — без DOM, без сети,
 * без React.
 *
 * 🔴 Почему отдельно, а не в странице: подпись нужна ОБЕИМ сторонам — кабинету
 * владельца и публичной странице участника. Импорт из страницы кабинета тащил
 * бы в публичный `/j/chat` весь каркас ЛК (шапку, меню, axios ЛК) — лишний вес
 * и лишняя связность там, где у человека нет даже учётной записи.
 */
import { principalKey } from './deviceFanout';

/**
 * Ростер -> «имена навсегда» -> честная заглушка.
 *
 * 🔴 Последняя ступень обязательна (§6 дизайна): вышедшего или удалённого в
 * ростере уже нет, а его сообщения в истории остались. Без неё история после
 * первого же выхода участника показывала бы пустые подписи — и человек решил
 * бы, что сообщение пришло непонятно от кого.
 */
export function senderName(state, type, id) {
  return knownSenderName(state, type, id) ?? 'Участник вышел';
}

/**
 * То же самое, но без заглушки: `null` = имени мы НЕ ЗНАЕМ.
 *
 * 🔴 Нужно там, где имя уезжает ЧУЖОМУ человеку (снимок цитаты,
 * WEB-16): подписать его нашей заглушкой «Участник вышел» значило бы
 * сообщить чужому клиенту не имя, а НАШЕ незнание — и он показал бы его
 * как имя автора.
 */
export function knownSenderName(state, type, id) {
  const key = principalKey(type, id);
  return state?.membersByPrincipal?.[key]?.displayName
    ?? state?.namesByPrincipal?.[key]
    ?? null;
}
